export default [
  { id: 0, title: 'weiblich', is_default: true },
  { id: 1, title: 'männlich', is_default: false },
];
